module.exports = __webpack_public_path__ + "img/efc3e43.png";